// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
let envHostName: string = '';
let envEnvName: string = 'prod';
let envProduction: boolean = true;
let envObj: any = {};
//envHostName = 'https://dspin-sit-ext.p2g.netd2.hk.hsbc';
envObj = {
      production: envProduction,
      envName: envEnvName,
      envHostName:"ENV_envHostName",
      getAuthId: "ENV_usernameEndPoint",
      usernameEndPoint: "ENV_usernameEndPoint",
      passwordEndPoint: "ENV_passwordEndPoint",
      otpEndPoint: "ENV_otpEndPoint",
      loginEndPoint: "ENV_loginEndPoint",
      getSessionInfoEndPoint: "ENV_getSessionInfoEndPoint",
      memansOtpEndPoint: "ENV_memansOtpEndPoint",
      memansPwdEndPoint: "ENV_memansPwdEndPoint",
      dobPasswordEndPoint: "ENV_dobPasswordEndPoint",
      dobOtpEndPoint: "ENV_dobOtpEndPoint",
      verifySecurityAnsEndPoint: "ENV_verifySecurityAnsEndPoint",
      passwordResetCodeEndPoint: "ENV_passwordResetCodeEndPoint",
      passwordRecoveryMethodEndPoint: "ENV_passwordRecoveryMethodEndPoint",
      getDSPSession: "ENV_getDSPSession",
      verifyIdentityForRegEndpoint: "ENV_verifyIdentityForRegEndpoint",
      dpPolicyPoint: "ENV_dpPolicyPoint",
      cam2040EndPoint: "ENV_cam2040EndPoint",
      method: "POST"
    };

export const environment = envObj;
